import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SettingsService = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsService, _super);
    function SettingsService(http, _http) {
        var _this = _super.call(this, http, MapperService.settingMap) || this;
        _this._http = _http;
        _this._endpoint = '/odata/Settings/UiPath.Server.Configuration.OData.GetWebSettings';
        return _this;
    }
    SettingsService.prototype.setLanguage = function (languageCode) {
        var payload = JSON.stringify({ culture: languageCode });
        return this._http.post("/odata/Users/UiPath.Server.Configuration.OData.ChangeCulture()", payload);
    };
    SettingsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SettingsService_Factory() { return new SettingsService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i1.HttpClient)); }, token: SettingsService, providedIn: "root" });
    return SettingsService;
}(ODataService));
export { SettingsService };
